// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__edT-e","card":"Contact_card__onGJR","card2":"Contact_card2__T5JLx","icons":"Contact_icons__UWkG0","section":"Contact_section__Cn2gI"};